// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file api/gateway/v1/location.proto (package gateway.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Pagination, PaginationMetadata } from "./core_pb";
import { file_api_gateway_v1_core } from "./core_pb";
import type { InstallationState } from "./installation_state_pb";
import { file_api_gateway_v1_installation_state } from "./installation_state_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/gateway/v1/location.proto.
 */
export const file_api_gateway_v1_location: GenFile = /*@__PURE__*/
  fileDesc("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", [file_api_gateway_v1_core, file_api_gateway_v1_installation_state, file_google_protobuf_timestamp]);

/**
 * Location represents a physical address or coordinate tied to installations.
 *
 * @generated from message gateway.v1.Location
 */
export type Location = Message<"gateway.v1.Location"> & {
  /**
   * uuid is the unique identifier for the location.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;

  /**
   * name is the display name of the location.
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * address is the street address of the location.
   *
   * @generated from field: string address = 3;
   */
  address: string;

  /**
   * cp is the postal code of the location.
   *
   * @generated from field: string cp = 4;
   */
  cp: string;

  /**
   * city is the city where the location is situated.
   *
   * @generated from field: string city = 5;
   */
  city: string;

  /**
   * country is the country where the location is situated.
   *
   * @generated from field: string country = 6;
   */
  country: string;

  /**
   * latitude is the geographic latitude coordinate.
   *
   * @generated from field: double latitude = 7;
   */
  latitude: number;

  /**
   * longitude is the geographic longitude coordinate.
   *
   * @generated from field: double longitude = 8;
   */
  longitude: number;

  /**
   * erp_id is the external ERP identifier for the location.
   *
   * @generated from field: string erp_id = 9;
   */
  erpId: string;

  /**
   * tenant_uuid is the unique identifier of the tenant that owns this location.
   *
   * @generated from field: string tenant_uuid = 10;
   */
  tenantUuid: string;

  /**
   * created_at timestamp when the location was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */
  createdAt?: Timestamp | undefined;

  /**
   * updated_at timestamp when the location was last updated.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * admin_uuid is the admin of the location
   *
   * @generated from field: string admin_uuid = 13;
   */
  adminUuid: string;

  /**
   * number_of_floors is the number of floors in the building.
   *
   * @generated from field: optional int32 number_of_floors = 14;
   */
  numberOfFloors?: number | undefined;

  /**
   * number_of_apartments is the number of apartments in the building.
   *
   * @generated from field: optional int32 number_of_apartments = 15;
   */
  numberOfApartments?: number | undefined;

  /**
   * number_of_commercial_units is the number of commercial units in the building.
   *
   * @generated from field: optional int32 number_of_commercial_units = 16;
   */
  numberOfCommercialUnits?: number | undefined;

  /**
   * building_area_m2 is the building area in square meters.
   *
   * @generated from field: optional double building_area_m2 = 17;
   */
  buildingAreaM2?: number | undefined;

  /**
   * average_age is the average age of the building occupants.
   *
   * @generated from field: optional double average_age = 18;
   */
  averageAge?: number | undefined;

  /**
   * number_of_people is the number of people in the building (actual or calculated value).
   *
   * @generated from field: optional int32 number_of_people = 19;
   */
  numberOfPeople?: number | undefined;

  /**
   * roof_area_m2 is the building roof area in square meters, manually entered by the client.
   *
   * @generated from field: optional double roof_area_m2 = 20;
   */
  roofAreaM2?: number | undefined;

  /**
   * has_rainwater_harvesting indicates whether the building has rainwater harvesting.
   *
   * @generated from field: optional bool has_rainwater_harvesting = 21;
   */
  hasRainwaterHarvesting?: boolean | undefined;
};

/**
 * Describes the message gateway.v1.Location.
 * Use `create(LocationSchema)` to create a new message.
 */
export const LocationSchema: GenMessage<Location> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_location, 0);

/**
 * CreateLocationRequest is the request message for creating a new location.
 *
 * @generated from message gateway.v1.CreateLocationRequest
 */
export type CreateLocationRequest = Message<"gateway.v1.CreateLocationRequest"> & {
  /**
   * name is the display name for the new location.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * address is the street address of the new location.
   *
   * @generated from field: string address = 2;
   */
  address: string;

  /**
   * cp is the postal code of the new location.
   *
   * @generated from field: string cp = 3;
   */
  cp: string;

  /**
   * city is the city where the new location is situated.
   *
   * @generated from field: string city = 4;
   */
  city: string;

  /**
   * country is the country where the new location is situated.
   *
   * @generated from field: string country = 5;
   */
  country: string;

  /**
   * latitude is the geographic latitude coordinate.
   *
   * @generated from field: double latitude = 6;
   */
  latitude: number;

  /**
   * longitude is the geographic longitude coordinate.
   *
   * @generated from field: double longitude = 7;
   */
  longitude: number;

  /**
   * erp_id is the external ERP identifier for the location.
   *
   * @generated from field: string erp_id = 8;
   */
  erpId: string;

  /**
   * tenant_uuid is the unique identifier of the tenant that owns this location.
   *
   * @generated from field: string tenant_uuid = 9;
   */
  tenantUuid: string;

  /**
   * admin_uuid is the admin of the location
   *
   * @generated from field: string admin_uuid = 10;
   */
  adminUuid: string;

  /**
   * number_of_floors is the number of floors in the building.
   *
   * @generated from field: optional int32 number_of_floors = 11;
   */
  numberOfFloors?: number | undefined;

  /**
   * number_of_apartments is the number of apartments in the building.
   *
   * @generated from field: optional int32 number_of_apartments = 12;
   */
  numberOfApartments?: number | undefined;

  /**
   * number_of_commercial_units is the number of commercial units in the building.
   *
   * @generated from field: optional int32 number_of_commercial_units = 13;
   */
  numberOfCommercialUnits?: number | undefined;

  /**
   * building_area_m2 is the building area in square meters.
   *
   * @generated from field: optional double building_area_m2 = 14;
   */
  buildingAreaM2?: number | undefined;

  /**
   * average_age is the average age of the building occupants.
   *
   * @generated from field: optional double average_age = 15;
   */
  averageAge?: number | undefined;

  /**
   * number_of_people is the number of people in the building (actual or calculated value).
   *
   * @generated from field: optional int32 number_of_people = 16;
   */
  numberOfPeople?: number | undefined;

  /**
   * roof_area_m2 is the building roof area in square meters, manually entered by the client.
   *
   * @generated from field: optional double roof_area_m2 = 17;
   */
  roofAreaM2?: number | undefined;

  /**
   * has_rainwater_harvesting indicates whether the building has rainwater harvesting.
   *
   * @generated from field: optional bool has_rainwater_harvesting = 18;
   */
  hasRainwaterHarvesting?: boolean | undefined;
};

/**
 * Describes the message gateway.v1.CreateLocationRequest.
 * Use `create(CreateLocationRequestSchema)` to create a new message.
 */
export const CreateLocationRequestSchema: GenMessage<CreateLocationRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_location, 1);

/**
 * CreateLocationResponse is the response message for the CreateLocation RPC.
 *
 * @generated from message gateway.v1.CreateLocationResponse
 */
export type CreateLocationResponse = Message<"gateway.v1.CreateLocationResponse"> & {
  /**
   * location is the newly created location.
   *
   * @generated from field: gateway.v1.Location location = 1;
   */
  location?: Location | undefined;
};

/**
 * Describes the message gateway.v1.CreateLocationResponse.
 * Use `create(CreateLocationResponseSchema)` to create a new message.
 */
export const CreateLocationResponseSchema: GenMessage<CreateLocationResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_location, 2);

/**
 * GetLocationByUuidRequest is the request message for retrieving a location by UUID.
 *
 * @generated from message gateway.v1.GetLocationByUuidRequest
 */
export type GetLocationByUuidRequest = Message<"gateway.v1.GetLocationByUuidRequest"> & {
  /**
   * uuid is the unique identifier of the location to retrieve.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;
};

/**
 * Describes the message gateway.v1.GetLocationByUuidRequest.
 * Use `create(GetLocationByUuidRequestSchema)` to create a new message.
 */
export const GetLocationByUuidRequestSchema: GenMessage<GetLocationByUuidRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_location, 3);

/**
 * GetLocationByUuidResponse is the response message for the GetLocationByUuid RPC.
 *
 * @generated from message gateway.v1.GetLocationByUuidResponse
 */
export type GetLocationByUuidResponse = Message<"gateway.v1.GetLocationByUuidResponse"> & {
  /**
   * location is the location retrieved based on the provided UUID.
   *
   * @generated from field: gateway.v1.Location location = 1;
   */
  location?: Location | undefined;
};

/**
 * Describes the message gateway.v1.GetLocationByUuidResponse.
 * Use `create(GetLocationByUuidResponseSchema)` to create a new message.
 */
export const GetLocationByUuidResponseSchema: GenMessage<GetLocationByUuidResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_location, 4);

/**
 * GetLocationListByPageRequest is the request message for retrieving a paginated list of locations.
 *
 * @generated from message gateway.v1.GetLocationListByPageRequest
 */
export type GetLocationListByPageRequest = Message<"gateway.v1.GetLocationListByPageRequest"> & {
  /**
   * pagination contains the pagination parameters.
   *
   * @generated from field: gateway.v1.Pagination pagination = 1;
   */
  pagination?: Pagination | undefined;
};

/**
 * Describes the message gateway.v1.GetLocationListByPageRequest.
 * Use `create(GetLocationListByPageRequestSchema)` to create a new message.
 */
export const GetLocationListByPageRequestSchema: GenMessage<GetLocationListByPageRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_location, 5);

/**
 * GetLocationListByPageResponse is the response message for the GetLocationListByPage RPC.
 *
 * @generated from message gateway.v1.GetLocationListByPageResponse
 */
export type GetLocationListByPageResponse = Message<"gateway.v1.GetLocationListByPageResponse"> & {
  /**
   * locations is the list of locations for the requested page.
   *
   * @generated from field: repeated gateway.v1.Location locations = 1;
   */
  locations: Location[];

  /**
   * metadata contains pagination information.
   *
   * @generated from field: gateway.v1.PaginationMetadata metadata = 2;
   */
  metadata?: PaginationMetadata | undefined;
};

/**
 * Describes the message gateway.v1.GetLocationListByPageResponse.
 * Use `create(GetLocationListByPageResponseSchema)` to create a new message.
 */
export const GetLocationListByPageResponseSchema: GenMessage<GetLocationListByPageResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_location, 6);

/**
 * GetLocationListByERPIdRequest is the request message for retrieving locations by ERP identifier.
 *
 * @generated from message gateway.v1.GetLocationListByERPIdRequest
 */
export type GetLocationListByERPIdRequest = Message<"gateway.v1.GetLocationListByERPIdRequest"> & {
  /**
   * erp_id is the search term matched against location ERP identifiers.
   *
   * @generated from field: string erp_id = 1;
   */
  erpId: string;

  /**
   * pagination contains the pagination parameters for retrieving a specific page of matching locations.
   *
   * @generated from field: gateway.v1.Pagination pagination = 2;
   */
  pagination?: Pagination | undefined;
};

/**
 * Describes the message gateway.v1.GetLocationListByERPIdRequest.
 * Use `create(GetLocationListByERPIdRequestSchema)` to create a new message.
 */
export const GetLocationListByERPIdRequestSchema: GenMessage<GetLocationListByERPIdRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_location, 7);

/**
 * GetLocationListByERPIdResponse is the response message for the GetLocationListByERPId RPC.
 *
 * @generated from message gateway.v1.GetLocationListByERPIdResponse
 */
export type GetLocationListByERPIdResponse = Message<"gateway.v1.GetLocationListByERPIdResponse"> & {
  /**
   * locations is the list of locations whose ERP identifier matches the provided search term for the requested page.
   *
   * @generated from field: repeated gateway.v1.Location locations = 1;
   */
  locations: Location[];

  /**
   * metadata contains pagination information.
   *
   * @generated from field: gateway.v1.PaginationMetadata metadata = 2;
   */
  metadata?: PaginationMetadata | undefined;
};

/**
 * Describes the message gateway.v1.GetLocationListByERPIdResponse.
 * Use `create(GetLocationListByERPIdResponseSchema)` to create a new message.
 */
export const GetLocationListByERPIdResponseSchema: GenMessage<GetLocationListByERPIdResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_location, 8);

/**
 * GetLocationListByAddressRequest is the request message for retrieving locations by address.
 *
 * @generated from message gateway.v1.GetLocationListByAddressRequest
 */
export type GetLocationListByAddressRequest = Message<"gateway.v1.GetLocationListByAddressRequest"> & {
  /**
   * address is the search term matched against location addresses.
   *
   * @generated from field: string address = 1;
   */
  address: string;

  /**
   * pagination contains the pagination parameters for retrieving a specific page of matching locations.
   *
   * @generated from field: gateway.v1.Pagination pagination = 2;
   */
  pagination?: Pagination | undefined;
};

/**
 * Describes the message gateway.v1.GetLocationListByAddressRequest.
 * Use `create(GetLocationListByAddressRequestSchema)` to create a new message.
 */
export const GetLocationListByAddressRequestSchema: GenMessage<GetLocationListByAddressRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_location, 9);

/**
 * GetLocationListByAddressResponse is the response message for the GetLocationListByAddress RPC.
 *
 * @generated from message gateway.v1.GetLocationListByAddressResponse
 */
export type GetLocationListByAddressResponse = Message<"gateway.v1.GetLocationListByAddressResponse"> & {
  /**
   * locations is the list of locations whose address matches the provided search term for the requested page.
   *
   * @generated from field: repeated gateway.v1.Location locations = 1;
   */
  locations: Location[];

  /**
   * metadata contains pagination information.
   *
   * @generated from field: gateway.v1.PaginationMetadata metadata = 2;
   */
  metadata?: PaginationMetadata | undefined;
};

/**
 * Describes the message gateway.v1.GetLocationListByAddressResponse.
 * Use `create(GetLocationListByAddressResponseSchema)` to create a new message.
 */
export const GetLocationListByAddressResponseSchema: GenMessage<GetLocationListByAddressResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_location, 10);

/**
 * UpdateLocationRequest is the request message for updating an existing location.
 *
 * @generated from message gateway.v1.UpdateLocationRequest
 */
export type UpdateLocationRequest = Message<"gateway.v1.UpdateLocationRequest"> & {
  /**
   * uuid is the unique identifier of the location to update.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;

  /**
   * name is the updated display name.
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * address is the updated street address.
   *
   * @generated from field: string address = 3;
   */
  address: string;

  /**
   * cp is the updated postal code.
   *
   * @generated from field: string cp = 4;
   */
  cp: string;

  /**
   * city is the updated city.
   *
   * @generated from field: string city = 5;
   */
  city: string;

  /**
   * country is the updated country.
   *
   * @generated from field: string country = 6;
   */
  country: string;

  /**
   * latitude is the updated geographic latitude coordinate.
   *
   * @generated from field: double latitude = 7;
   */
  latitude: number;

  /**
   * longitude is the updated geographic longitude coordinate.
   *
   * @generated from field: double longitude = 8;
   */
  longitude: number;

  /**
   * erp_id is the updated external ERP identifier.
   *
   * @generated from field: string erp_id = 9;
   */
  erpId: string;

  /**
   * tenant_uuid is the unique identifier of the tenant that owns this location.
   *
   * @generated from field: string tenant_uuid = 10;
   */
  tenantUuid: string;

  /**
   * admin_uuid is the admin of the location
   *
   * @generated from field: string admin_uuid = 11;
   */
  adminUuid: string;

  /**
   * number_of_floors is the number of floors in the building.
   *
   * @generated from field: optional int32 number_of_floors = 12;
   */
  numberOfFloors?: number | undefined;

  /**
   * number_of_apartments is the number of apartments in the building.
   *
   * @generated from field: optional int32 number_of_apartments = 13;
   */
  numberOfApartments?: number | undefined;

  /**
   * number_of_commercial_units is the number of commercial units in the building.
   *
   * @generated from field: optional int32 number_of_commercial_units = 14;
   */
  numberOfCommercialUnits?: number | undefined;

  /**
   * building_area_m2 is the building area in square meters.
   *
   * @generated from field: optional double building_area_m2 = 15;
   */
  buildingAreaM2?: number | undefined;

  /**
   * average_age is the average age of the building occupants.
   *
   * @generated from field: optional double average_age = 16;
   */
  averageAge?: number | undefined;

  /**
   * number_of_people is the number of people in the building (actual or calculated value).
   *
   * @generated from field: optional int32 number_of_people = 17;
   */
  numberOfPeople?: number | undefined;

  /**
   * roof_area_m2 is the building roof area in square meters, manually entered by the client.
   *
   * @generated from field: optional double roof_area_m2 = 18;
   */
  roofAreaM2?: number | undefined;

  /**
   * has_rainwater_harvesting indicates whether the building has rainwater harvesting.
   *
   * @generated from field: optional bool has_rainwater_harvesting = 19;
   */
  hasRainwaterHarvesting?: boolean | undefined;
};

/**
 * Describes the message gateway.v1.UpdateLocationRequest.
 * Use `create(UpdateLocationRequestSchema)` to create a new message.
 */
export const UpdateLocationRequestSchema: GenMessage<UpdateLocationRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_location, 11);

/**
 * UpdateLocationResponse is the response message for the UpdateLocation RPC.
 *
 * @generated from message gateway.v1.UpdateLocationResponse
 */
export type UpdateLocationResponse = Message<"gateway.v1.UpdateLocationResponse"> & {
  /**
   * location is the updated location.
   *
   * @generated from field: gateway.v1.Location location = 1;
   */
  location?: Location | undefined;
};

/**
 * Describes the message gateway.v1.UpdateLocationResponse.
 * Use `create(UpdateLocationResponseSchema)` to create a new message.
 */
export const UpdateLocationResponseSchema: GenMessage<UpdateLocationResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_location, 12);

/**
 * DeleteLocationRequest is the request message for deleting a location.
 *
 * @generated from message gateway.v1.DeleteLocationRequest
 */
export type DeleteLocationRequest = Message<"gateway.v1.DeleteLocationRequest"> & {
  /**
   * uuid is the unique identifier of the location to delete.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;
};

/**
 * Describes the message gateway.v1.DeleteLocationRequest.
 * Use `create(DeleteLocationRequestSchema)` to create a new message.
 */
export const DeleteLocationRequestSchema: GenMessage<DeleteLocationRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_location, 13);

/**
 * DeleteLocationResponse is the response message for the DeleteLocation RPC.
 *
 * @generated from message gateway.v1.DeleteLocationResponse
 */
export type DeleteLocationResponse = Message<"gateway.v1.DeleteLocationResponse"> & {
};

/**
 * Describes the message gateway.v1.DeleteLocationResponse.
 * Use `create(DeleteLocationResponseSchema)` to create a new message.
 */
export const DeleteLocationResponseSchema: GenMessage<DeleteLocationResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_location, 14);

/**
 * @generated from message gateway.v1.LocationInstallationWorstState
 */
export type LocationInstallationWorstState = Message<"gateway.v1.LocationInstallationWorstState"> & {
  /**
   * @generated from field: gateway.v1.Location location = 1;
   */
  location?: Location | undefined;

  /**
   * @generated from field: gateway.v1.InstallationState state = 2;
   */
  state?: InstallationState | undefined;
};

/**
 * Describes the message gateway.v1.LocationInstallationWorstState.
 * Use `create(LocationInstallationWorstStateSchema)` to create a new message.
 */
export const LocationInstallationWorstStateSchema: GenMessage<LocationInstallationWorstState> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_location, 15);

/**
 * @generated from message gateway.v1.GetAllLocationsWithInstallationWorstStateRequest
 */
export type GetAllLocationsWithInstallationWorstStateRequest = Message<"gateway.v1.GetAllLocationsWithInstallationWorstStateRequest"> & {
};

/**
 * Describes the message gateway.v1.GetAllLocationsWithInstallationWorstStateRequest.
 * Use `create(GetAllLocationsWithInstallationWorstStateRequestSchema)` to create a new message.
 */
export const GetAllLocationsWithInstallationWorstStateRequestSchema: GenMessage<GetAllLocationsWithInstallationWorstStateRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_location, 16);

/**
 * @generated from message gateway.v1.GetAllLocationsWithInstallationWorstStateResponse
 */
export type GetAllLocationsWithInstallationWorstStateResponse = Message<"gateway.v1.GetAllLocationsWithInstallationWorstStateResponse"> & {
  /**
   * @generated from field: repeated gateway.v1.LocationInstallationWorstState locations = 1;
   */
  locations: LocationInstallationWorstState[];
};

/**
 * Describes the message gateway.v1.GetAllLocationsWithInstallationWorstStateResponse.
 * Use `create(GetAllLocationsWithInstallationWorstStateResponseSchema)` to create a new message.
 */
export const GetAllLocationsWithInstallationWorstStateResponseSchema: GenMessage<GetAllLocationsWithInstallationWorstStateResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_location, 17);

/**
 * LocationService defines the gRPC service for managing locations.
 *
 * -------------------------------------------------------------------------
 * Location CRUD operations
 * -------------------------------------------------------------------------
 *
 * @generated from service gateway.v1.LocationService
 */
export const LocationService: GenService<{
  /**
   * CreateLocation creates a new location in the system.
   *
   * @generated from rpc gateway.v1.LocationService.CreateLocation
   */
  createLocation: {
    methodKind: "unary";
    input: typeof CreateLocationRequestSchema;
    output: typeof CreateLocationResponseSchema;
  },
  /**
   * GetLocationByUuid retrieves a location by its unique identifier.
   * TODO
   *
   * @generated from rpc gateway.v1.LocationService.GetLocationByUuid
   */
  getLocationByUuid: {
    methodKind: "unary";
    input: typeof GetLocationByUuidRequestSchema;
    output: typeof GetLocationByUuidResponseSchema;
  },
  /**
   * GetLocationListByPage retrieves a paginated list of locations.
   * TODO
   *
   * @generated from rpc gateway.v1.LocationService.GetLocationListByPage
   */
  getLocationListByPage: {
    methodKind: "unary";
    input: typeof GetLocationListByPageRequestSchema;
    output: typeof GetLocationListByPageResponseSchema;
  },
  /**
   * GetLocationListByERPId retrieves a paginated list of locations whose ERP identifier matches the given search term.
   *
   * @generated from rpc gateway.v1.LocationService.GetLocationListByERPId
   */
  getLocationListByERPId: {
    methodKind: "unary";
    input: typeof GetLocationListByERPIdRequestSchema;
    output: typeof GetLocationListByERPIdResponseSchema;
  },
  /**
   * GetLocationListByAddress retrieves a paginated list of locations whose address matches the given search term.
   *
   * @generated from rpc gateway.v1.LocationService.GetLocationListByAddress
   */
  getLocationListByAddress: {
    methodKind: "unary";
    input: typeof GetLocationListByAddressRequestSchema;
    output: typeof GetLocationListByAddressResponseSchema;
  },
  /**
   * UpdateLocation updates an existing location.
   *
   * @generated from rpc gateway.v1.LocationService.UpdateLocation
   */
  updateLocation: {
    methodKind: "unary";
    input: typeof UpdateLocationRequestSchema;
    output: typeof UpdateLocationResponseSchema;
  },
  /**
   * DeleteLocation removes a location from the system.
   *
   * @generated from rpc gateway.v1.LocationService.DeleteLocation
   */
  deleteLocation: {
    methodKind: "unary";
    input: typeof DeleteLocationRequestSchema;
    output: typeof DeleteLocationResponseSchema;
  },
  /**
   * GetAllLocationsWithInstallationState retrieves all locations along with their associated installation states.
   *
   * @generated from rpc gateway.v1.LocationService.GetAllLocationsWithInstallationWorstState
   */
  getAllLocationsWithInstallationWorstState: {
    methodKind: "unary";
    input: typeof GetAllLocationsWithInstallationWorstStateRequestSchema;
    output: typeof GetAllLocationsWithInstallationWorstStateResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_gateway_v1_location, 0);

